import "./footer.css"


const Footer = () => {
    return (
        <footer id="footer" className="footer" >
            <div style={{ textAlign: "center", width: "100%", padding: "1px", backgroundColor: "black", color: "white" }}>
            <p id="contact">Créé par: Pask</p>
            <p>Tous droits presque réservés.</p> 
            </div>
        </footer>
    );
}

export default Footer;